import { gql } from "@apollo/client";

import { CUSTOM_VIEW_FIELDS, USER_VIEW_PREFERENCE_FIELDS } from "./fragments";

export const LIST_CUSTOM_VIEWS = "listCustomViews";
export const GET_CUSTOM_VIEW = "getCustomView";
export const GET_CUSTOM_VIEW_MODULE_META = "getCustomViewModuleMeta";
export const GET_USER_VIEW_PREFERENCE = "getUserViewPreference";

export const LIST_CUSTOM_VIEWS_QUERY = gql`
  query ${LIST_CUSTOM_VIEWS}($module: CustomViewModule!) {
    ${LIST_CUSTOM_VIEWS}(module: $module) {
      views {
        ...CustomViewFields
      }
      preference {
        ...UserViewPreferenceFields
      }
      tabLimit
      nameMaxLength
      canCreateShared
    }
  }
  ${CUSTOM_VIEW_FIELDS}
  ${USER_VIEW_PREFERENCE_FIELDS}
`;

export const GET_CUSTOM_VIEW_QUERY = gql`
  query ${GET_CUSTOM_VIEW}($id: ID!) {
    ${GET_CUSTOM_VIEW}(id: $id) {
      ...CustomViewFields
    }
  }
  ${CUSTOM_VIEW_FIELDS}
`;

export const GET_CUSTOM_VIEW_MODULE_META_QUERY = gql`
  query ${GET_CUSTOM_VIEW_MODULE_META}($module: CustomViewModule!) {
    ${GET_CUSTOM_VIEW_MODULE_META}(module: $module) {
      module
      availableTypes: availableViewTypes
      sortFields {
        field: key
        label
      }
      sortDisabledViewTypes
    }
  }
`;

export const GET_USER_VIEW_PREFERENCE_QUERY = gql`
  query ${GET_USER_VIEW_PREFERENCE}($module: CustomViewModule!) {
    ${GET_USER_VIEW_PREFERENCE}(module: $module) {
      ...UserViewPreferenceFields
    }
  }
  ${USER_VIEW_PREFERENCE_FIELDS}
`;
